import { render } from "./tenChallengeState.vue?vue&type=template&id=4ddf237f&scoped=true"
import script from "./tenChallengeState.vue?vue&type=script&lang=js"
export * from "./tenChallengeState.vue?vue&type=script&lang=js"

import "./tenChallengeState.vue?vue&type=style&index=0&id=4ddf237f&lang=less&scoped=true"

import exportComponent from "C:\\Users\\Administrator.DESKTOP-7G84OHA\\Desktop\\dduh-active-webh5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ddf237f"]])

export default __exports__